"use client"
import React, { useEffect, useState, useContext, useCallback } from "react";
import api from '@utils/api';
import { ChartContext } from "@contexts/ChartContext";
import { toast } from 'react-toastify';
import styles from "./modal.module.css";
const SearchModal = ({ isOpen, onClose }) => {
  const {

    activeWatcherIndex,
    setWatchersUpdated,
    isSearchModalOpen,
    setIsSearchModalOpen,
    translatedTexts
  } = useContext(ChartContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeCategory, setActiveCategory] = useState("همه");
  const [searchResults, setSearchResults] = useState([]);

  const categories = ["همه", "بورس تهران", "ارز و طلا"];
  // const categories = ["همه", "بورس تهران","ارز و طلا", "کریپتو", "مسکن"];


  const datafeed_prefix = `${process.env.REACT_APP_API_URL}/trading-view`;

  useEffect(() => {

    let time_outed_request = setTimeout(async () => {
      const data = await api.get(`${datafeed_prefix}/search?type=${activeCategory}&query=${searchTerm.toUpperCase()}&limit=5000`).then(res => res.data);
      setSearchResults(data)
    }, 1000)

    return () => {
      clearTimeout(time_outed_request);
    }
  }, [searchTerm, activeCategory])



  const addSymbolToWatcher = async (item) => {

    try {
      const response = await api.post(`/panel/market-watch/add`, { ...item, watcher_id: activeWatcherIndex }).then(res => res.data);

      if (response.status) {
        toast.success(response.message)
        setWatchersUpdated(true)
        setIsSearchModalOpen(false)

      } else {
        toast.error(response.message)
      }

    } catch (e) {
      toast.error("Something went wrong...")


    }

  }


  if (!isOpen) return null;


  return (
    <div className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 text-tt-content ${translatedTexts?.class?.direction}`} >
      <div className="bg-tt-100 w-11/12 max-w-3xl rounded-lg shadow-lg p-6 relative">
        <button
          onClick={onClose}
          className={`absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-2xl`}
        >
          &times;
        </button>


        <div className="relative mb-4 mt-4">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder={translatedTexts?.modal?.watchlist_item_add?.search_input_placeholder}

            className={`w-full p-3   ${styles.chartTextInput}  rounded-lg focus:outline-none focus:none`}
          />
          {/* Clear Button */}
          {searchTerm && (
            <button
              onClick={() => setSearchTerm("")}
              className={`absolute ${translatedTexts?.class?.direction == "dir-ltr" ? "right" : "left"}-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600`}
            >
              &times;
            </button>
          )}
        </div>

        {/* Category Filters */}
        <div className="mb-4 flex ">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-4 py-2 mx-0.5 rounded-lg ${activeCategory === category
                ? "bg-blue-500 text-white"
                : "bg-blue-100 text-blue-500"
                } uppercase`}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="overflow-x-auto">
          <div style={{ height: "300px" }}>
            <table className="w-full table-auto border-collapse" >
              <thead>
                <tr className="text-gray-400  uppercase text-sm">


                  <th className={`py-3 px-6 font-medium text-${translatedTexts?.class?.direction == "dir-ltr" ? "left" : "right"}`}>{translatedTexts?.modal?.watchlist_item_add?.symbol}</th>
                  <th className="py-3 px-6 font-medium text-center">{translatedTexts?.modal?.watchlist_item_add?.description} </th>
                  <th className="py-3 px-6 font-medium text-center">{translatedTexts?.modal?.watchlist_item_add?.market}</th>
                </tr>
              </thead>
              <tbody>
                {searchResults.map((item, index) => (
                  <tr
                    key={index}
                    className=" btn-grey-hover cursor-pointer"
                    onClick={() => { addSymbolToWatcher(item) }}
                  >
                    <td className={`py-3 px-6text-${translatedTexts?.class?.direction == "dir-ltr" ? "left" : "right"}`}>{item.symbol}</td>
                    <td className="py-3 px-6 text-center">{item.description}</td>
                    <td className="py-3 px-6 text-center uppercase">{item.type}</td>
                  </tr>
                ))}
                {searchResults.length === 0 && (
                  <tr>
                    <td
                      colSpan="3"
                      className="py-3 px-6 text-center text-gray-500"
                    >
                      {translatedTexts?.modal?.watchlist_item_add?.no_record}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchModal;
